import { render, staticRenderFns } from "./cupons.vue?vue&type=template&id=7e2afc64&scoped=true"
import script from "./cupons.vue?vue&type=script&lang=js"
export * from "./cupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2afc64",
  null
  
)

export default component.exports